import { NavLink } from "react-router-dom";
import { useAppStore } from "../../store/useAppStore";

function Icon({ d, rect }: { d?: string; rect?: boolean }) {
  if (rect) {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="3" y="3" width="8" height="8" rx="1.5" />
        <rect x="13" y="3" width="8" height="8" rx="1.5" />
        <rect x="3" y="13" width="8" height="8" rx="1.5" />
        <rect x="13" y="13" width="8" height="8" rx="1.5" />
      </svg>
    );
  }
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={d} />
    </svg>
  );
}

const items = [
  { to: "/", label: "Today", d: "M3 11l9-7 9 7M5 9.5V20h14V9.5" },
  { to: "/units", label: "Units", rect: true },
  { to: "/work", label: "Work", d: "M9 12l2 2 4-5M4 3h16v18H4z" },
  { to: "/inbox", label: "Inbox", d: "M4 6h16v12H4zM4 7l8 6 8-6" },
  { to: "/more", label: "More", d: "" }
];

export function TabBar() {
  const inboxNeedsAttentionCount = useAppStore((s) => s.situations.filter((sit) => sit.category === "support" && sit.status === "open" && sit.needsAttention).length);

  return (
    <nav
      className="sticky bottom-0 z-10 flex border-t border-border bg-card px-2 pb-[max(10px,env(safe-area-inset-bottom))] pt-2"
      aria-label="Primary"
    >
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === "/"}
          className={({ isActive }) =>
            `touch-target flex flex-1 flex-col items-center justify-center gap-1 py-1 font-action text-[10.5px] font-bold tracking-wide ${
              isActive ? "text-primary" : "text-muted-foreground"
            }`
          }
        >
          <span className="relative">
            {item.label === "More" ? (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden="true">
                <circle cx="5" cy="12" r="1.6" />
                <circle cx="12" cy="12" r="1.6" />
                <circle cx="19" cy="12" r="1.6" />
              </svg>
            ) : (
              <Icon d={item.d} rect={item.rect} />
            )}
            {item.label === "Inbox" && inboxNeedsAttentionCount > 0 && (
              <span
                className="absolute -right-1 -top-1 h-2 w-2 rounded-full border-2 border-card bg-danger"
                aria-label={`${inboxNeedsAttentionCount} needing attention`}
              />
            )}
          </span>
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
